module.exports = "/images/zm.svg?426765315c9d86072b819416f42e375c";